import { opportunitiesRetrieveOptions } from '@crm/api'
import {
  ConvertOpportunity,
  InfoTabsOpportunities,
  OpportunityCard
} from '@crm/components'
import { NotFound } from '@crm/components/Error'
import { OpportunityContextProvider } from '@crm/contexts/OpportunityContext'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Col, Row, Spin } from 'antd'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export const OpportunitiesDetails = () => {
  const { t } = useLocales()
  const { opportunityId } = useParams()
  const [convertOpen, setConvertOpen] = useState(false)

  const { data, isLoading } = useQuery({
    ...opportunitiesRetrieveOptions({ path: { id: Number(opportunityId) } }),
    enabled: !!opportunityId
  })

  if (isLoading) return <Spin />

  return (
    <OpportunityContextProvider type="opportunity">
      {data ? (
        <>
          <TitleSection title={t('contracts.opportunity')}>
            <Button type="primary" onClick={() => setConvertOpen(true)}>
              {t('lead.convert_to_client')}
            </Button>
          </TitleSection>

          {convertOpen && (
            <ConvertOpportunity
              open
              opportunity={data}
              onCancel={() => setConvertOpen(false)}
            />
          )}

          <Row gutter={10}>
            <Col span={10} md={8} xxl={6}>
              <OpportunityCard opportunity={data} />
            </Col>
            <Col span={14} md={16} xxl={18}>
              <InfoTabsOpportunities />
            </Col>
          </Row>
        </>
      ) : (
        <NotFound />
      )}
    </OpportunityContextProvider>
  )
}
